import styled from "@emotion/styled";

import TemplateHero from "@/components/templates/TemplateHero";
import TemplateHeader from "@/components/templates/TemplateHeader";
import { TemplateButton } from "@/components/templates/TemplateButton";
import TemplateNavigation from '@/components/templates/TemplateNavigation'

const Layout = styled.section``;

Layout.Container = styled.div`
  overflow: hidden;
`;

Layout.Content = styled.div`
  position: relative;
  max-width: 1024px;
  margin: 0 auto;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: calc(var(--preview-height) - 80px);
  max-height: calc(var(--preview-height) - 80px);
`;

Layout.Header = styled(TemplateHeader)`
  height: 80px;
  position: relative;
`;

Layout.HeaderContent = styled.div`
  max-width: 1024px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
`;

Layout.Logo = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

Layout.LogoImage = styled.img`
  height: 70px;
  justify-self: flex-start;
`;

Layout.LogoText = styled.span`
  font-size: 22px;
`;

Layout.Hero = styled(TemplateHero)``;
Layout.HeroContainer = styled.div`
  position: relative;
  z-index: 1;
`;

Layout.HeroTitle = styled.h2`
  font-size: 64px;
  text-align: center;
`;

Layout.HeroDescription = styled.h6`
  font-size: 22px;
  margin-bottom: 14px;
  text-align: center;
`;

Layout.Menu = styled(TemplateNavigation)`
  display: flex;
  align-items: center;
  gap: 32px;
`;

Layout.PhoneButton = styled.button`
  text-transform: uppercase;
  line-height: 2.2;
  font-variant: normal;
  border-radius: 4px;
  font-size: 14px;
  border: solid 2px white;
  padding: 4px 26px;
  tab-index: -1;
  pointer-events: none;
  cursor: pointer;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
`;

Layout.CTA = styled(TemplateButton)`
  border-radius: 4px;
  padding: 6px 32px;
  font-weight: bold;
  line-height: 2.2;
  font-size: 20px;
`;

export default Layout;
